import { render, staticRenderFns } from "./Form.Tributos.vue?vue&type=template&id=737ec9da"
import script from "./Form.Tributos.vue?vue&type=script&lang=js"
export * from "./Form.Tributos.vue?vue&type=script&lang=js"
import style0 from "./Form.Tributos.vue?vue&type=style&index=0&id=737ec9da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports